import { useAuth } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import LogoutModal from './LogoutModal';

const styles = {
  nav: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '12px 20px',
    background: 'var(--bg-surface)',
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.06)',
  },
  logo: {
    fontSize: '22px',
    fontWeight: '700',
    background: 'linear-gradient(135deg, var(--accent), #f7a)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    cursor: 'pointer',
  },
  right: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
  },
  menuBtn: {
    position: 'relative',
  },
  avatar: {
    width: '34px',
    height: '34px',
    borderRadius: '50%',
    objectFit: 'cover',
    background: 'var(--bg-elevated)',
    cursor: 'pointer',
    border: '2px solid var(--border-color)',
  },
  dropdown: {
    position: 'absolute',
    top: '100%',
    right: 0,
    marginTop: '8px',
    background: 'var(--bg-surface)',
    border: '1px solid var(--border-color)',
    borderRadius: 'var(--radius-md)',
    padding: '4px',
    minWidth: '160px',
    boxShadow: 'var(--shadow-lg)',
    zIndex: 100,
  },
  dropdownItem: {
    display: 'block',
    width: '100%',
    padding: '10px 14px',
    textAlign: 'left',
    fontSize: '14px',
    borderRadius: 'var(--radius-sm)',
    color: 'var(--text-primary)',
    cursor: 'pointer',
    border: 'none',
    background: 'none',
  },
};

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [showLogoutModal, setShowLogoutModal] = useState(false);

  if (!user) return null;

  const handleLogoutClick = () => {
    setMenuOpen(false);
    if (user.is_generated) {
      setShowLogoutModal(true);
    } else {
      logout();
      navigate('/');
    }
  };

  const handleConfirmLogout = () => {
    setShowLogoutModal(false);
    logout();
    navigate('/');
  };

  return (
    <>
      <nav style={styles.nav}>
        <div style={styles.logo} onClick={() => navigate('/discover')}>
          nova
        </div>
        <div style={styles.right}>
          <div style={styles.menuBtn}>
            <div
              style={styles.avatar}
              onClick={() => setMenuOpen(!menuOpen)}
              role="button"
              tabIndex={0}
            >
              <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', fontSize: '14px' }}>
                {user.display_name?.[0]?.toUpperCase() || '?'}
              </span>
            </div>
            {menuOpen && (
              <div style={styles.dropdown}>
                <button
                  style={styles.dropdownItem}
                  onClick={() => { navigate('/profile'); setMenuOpen(false); }}
                  onMouseEnter={(e) => e.target.style.background = 'var(--bg-elevated)'}
                  onMouseLeave={(e) => e.target.style.background = 'none'}
                >
                  Profile
                </button>
                {user.is_admin === 1 && (
                  <button
                    style={styles.dropdownItem}
                    onClick={() => { navigate('/admin'); setMenuOpen(false); }}
                    onMouseEnter={(e) => e.target.style.background = 'var(--bg-elevated)'}
                    onMouseLeave={(e) => e.target.style.background = 'none'}
                  >
                    Admin
                  </button>
                )}
                <button
                  style={{ ...styles.dropdownItem, color: 'var(--danger)' }}
                  onClick={handleLogoutClick}
                  onMouseEnter={(e) => e.target.style.background = 'var(--bg-elevated)'}
                  onMouseLeave={(e) => e.target.style.background = 'none'}
                >
                  Log out
                </button>
              </div>
            )}
          </div>
        </div>
      </nav>

      {showLogoutModal && (
        <LogoutModal
          onClose={() => setShowLogoutModal(false)}
          onLogout={handleConfirmLogout}
        />
      )}
    </>
  );
}
